import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { toast } from 'sonner';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(username, password);
      toast.success('Login exitoso');
      navigate('/admin');
    } catch (error) {
      toast.error('Credenciales inválidas');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <Link to="/" className="block text-center mb-12">
          <h1 className="font-['Playfair_Display'] text-3xl tracking-tighter">HAUTE</h1>
          <p className="text-xs uppercase tracking-[0.2em] text-white/60 mt-2">Admin Panel</p>
        </Link>
        
        <div className="bg-[#0A0A0A] border border-white/10 p-8">
          <h2 className="text-xl font-semibold mb-6 text-center">Iniciar Sesión</h2>
          
          <form onSubmit={handleSubmit} data-testid="login-form">
            <div className="mb-6">
              <label className="block text-xs uppercase tracking-[0.2em] mb-3 text-white/80">Usuario</label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                data-testid="login-username"
                required
                className="w-full bg-transparent border-b border-white/20 focus:border-white outline-none px-0 py-4 text-white placeholder-gray-600 rounded-none transition-colors duration-300 font-light"
              />
            </div>
            
            <div className="mb-8">
              <label className="block text-xs uppercase tracking-[0.2em] mb-3 text-white/80">Contraseña</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="login-password"
                required
                className="w-full bg-transparent border-b border-white/20 focus:border-white outline-none px-0 py-4 text-white placeholder-gray-600 rounded-none transition-colors duration-300 font-light"
              />
            </div>
            
            <button
              type="submit"
              disabled={loading}
              data-testid="login-submit"
              className="w-full bg-white text-black hover:bg-gray-200 transition-colors duration-300 rounded-none px-10 py-5 uppercase tracking-widest text-xs font-semibold disabled:opacity-50"
            >
              {loading ? 'Iniciando...' : 'Iniciar Sesión'}
            </button>
          </form>
          
          <p className="text-xs text-center text-white/60 mt-6">
            <Link to="/admin/forgot" data-testid="forgot-password-link" className="text-white underline hover:text-white/80">
              ¿Olvidaste tu contraseña?
            </Link>
          </p>
          <p className="text-xs text-center text-white/60 mt-3">
            ¿No tienes cuenta? <Link to="/admin/register" className="text-white underline">Registrarse</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
